// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
import clsx from 'clsx';
import { getBaseProps } from '../internal/base-component';
import styles from './styles.css.js';
export default function InternalSkeleton({ variant, height, width, display, tagOverride, __internalRootRef, ...props }) {
    const baseProps = getBaseProps(props);
    const Tag = tagOverride;
    return (React.createElement(Tag, { ...baseProps, className: clsx(baseProps.className, styles.root, variant && styles[`variant-${variant}`], display && styles[`display-${display}`]), ref: __internalRootRef, style: width !== undefined ? { inlineSize: width } : {}, "aria-hidden": "true" },
        React.createElement(Tag, { className: styles.inner, style: height !== undefined ? { blockSize: height } : {} })));
}
//# sourceMappingURL=internal.js.map